
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class BodyRegister1 extends Vue {
  @Prop({ default: [] })
  private items!: Array<any>;
}
